import AutoplayModel from "slotworks/model/autoplay-model";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";

export function StopAutoplayCommand() {
    if(!campaignsModel.isFreespinsActive())
        AutoplayModel.stop();
    SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN, false);
    SmartButton.refresh();
}



// WEBPACK FOOTER //
// ./~/slotworks/commands/autoplay/stop-autoplay.ts